import { Modal } from "antd";
import colors from "core/resources/theme/colors";
import styled from "styled-components";

export const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background-color: ${colors.primary};
    * {
      color: white;
    }
    text-transform: uppercase;
  }

  .ant-modal-close-x {
    span {
      color: white;
      position: relative;
      top: -4px;
    }
  }
`;
